import { conditionReference } from "@utils/conditionData";
import { isEmpty } from "@utils/toolBox";


export function updateLoopTokens(cards) {
  const loopTokens = loopTokensByCardToken(cards);
  cards.forEach((card) => {
    const specs = card.specs ?? (card.specs = {});
    specs.loop_token = loopTokens.get(card.token);
  });
}

export function loopTokensByCardToken(cards) {
  const loopTokens = new Map();
  let currentLoop = null;
  cards.forEach((card) => {
    if (card.type === "o_loop" && card.specs?.position === "start") currentLoop = card.token;
    if (card.type === "o_loop" && card.specs?.position === "end") currentLoop = null;
    loopTokens.set(card.token, currentLoop);
  });
  return loopTokens;
}

export function deleteObsoleteConditions(cards, deletedCardToken) {
  cards.forEach((card) => {
    const specs = card.specs ?? {};

    if (!isEmpty(specs.conditions)) {
      const isGroup = "group_conditions" in specs.conditions[0];
      specs.conditions = isGroup
        ? specs.conditions.filter((group) => {
            group.group_conditions = group.group_conditions.filter(
              (condition) => !conditionReference(condition).includes(deletedCardToken),
            );
            return !isEmpty(group.group_conditions);
          })
        : specs.conditions.filter((condition) => !conditionReference(condition).includes(deletedCardToken));
    }

    if (!isEmpty(specs.redirects)) {
      specs.redirects = specs.redirects.filter((redirect) => redirect.next_card_token !== deletedCardToken);
    }

    ["items", "answers", "redirects", "screenouts", "ranges", "attribute_values"].forEach((fieldName) => {
      (specs[fieldName] ?? []).forEach((item) => {
        if (!item?.conditions) return;
        item.conditions = item.conditions.filter(
          (condition) => !conditionReference(condition).includes(deletedCardToken),
        );
      });
    });

    if (card.type === "o_loop" && specs.source_question_token === deletedCardToken) {
      specs.source_question_token = undefined;
      deleteObsoleteConditions(cards, card.token);
    }
  });
}
